import { useEffect, useRef } from "react";
import { PrivacyContent } from "./PrivacyContent";
import { TermsContent } from "./TermsContent";

export const LegalScroller = (props: {
  setHasScrolled?: () => void;
  type: "TERMS" | "PRIVACY";
}) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      (ref.current as any).scrollTop = 0;
    }
  }, [props.type]);

  return (
    <div
      ref={ref}
      onScroll={() => props.setHasScrolled?.()}
      className="flex-1 min-h-0 w-full p-4 sm:px-5 text-ink-2 flex flex-col gap-y-2 bg-surface"
      style={{ overflowY: "scroll" }}
    >
      {props.type === "TERMS" ? (
        <TermsContent />
      ) : (
        <PrivacyContent showDeleteAccountBlock="LINK" />
      )}
    </div>
  );
};
